import { Box } from "@mui/material";
import { FormDataConsumer, NumberInput, SaveButton, SelectInput, SimpleForm, TextInput, required } from "react-admin";
import CustomDeletedDialogToolbar from "shared/components/toolbars/CustomDeletedDialogToolbar";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { finlandGroupTypeChoices, franceGroupTypeChoices, groupModeChoices } from "shared/enums/reactAdminChoices";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { CodeTmInput, CountryInput } from "../shared/groupInputs";
import GroupMaskErrorAlert from "../shared/GroupMaskErrorAlert";

type GroupCreateFormProps = {
  handleSubmit: (values: any) => void;
};

const GroupCreateForm = ({ handleSubmit }: GroupCreateFormProps) => {
  return (
    <SimpleForm
      onSubmit={handleSubmit}
      mode="onBlur"
      shouldUnregister
      toolbar={
        <CustomDeletedDialogToolbar isCreateMode={true} resource={SiteResourcesEnum.Groups} resourceKey={"Group"}>
          <SaveButton />
        </CustomDeletedDialogToolbar>
      }
    >
      <Box display={"grid"} gridTemplateColumns={"repeat(4, 25%)"} width={"100%"} columnGap={2} pr={6}>
        <NumberInput
          source="group_number"
          validate={required()}
          helperText="The name will be the addition of the type + the number (ex: EDR 99)"
        />
        <CountryInput />
        <SelectInput source="mode" choices={groupModeChoices} validate={required()} />
        <TextInput source="code" validate={required()} />
      </Box>

      <FormDataConsumer>
        {({ formData }) => {
          const { country, type, code } = formData;
          const isFrance = country === SiteContryEnum.France;

          return (
            <Box>
              <Box display={"flex"} columnGap={2}>
                <SelectInput
                  source="type"
                  choices={isFrance ? franceGroupTypeChoices : finlandGroupTypeChoices}
                  validate={required()}
                  disabled={!country}
                />
                <CodeTmInput type={type} code={code} />
              </Box>
              <GroupMaskErrorAlert />
            </Box>
          );
        }}
      </FormDataConsumer>
    </SimpleForm>
  );
};

export default GroupCreateForm;
